(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["power-money"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){const trigger=e.target.closest('[data-sample]');if(trigger){document.getElementById('sample-dialog').showModal();}const close=e.target.closest('[data-close]');if(close){close.closest('dialog').close();}const checkout=e.target.closest('[data-preview-checkout]');if(checkout){document.getElementById('checkout-preview').showModal();}});document.addEventListener('click',function(e){if(e.target.tagName==='DIALOG'){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}});

  } catch(e) { console.error(e); }
})();
})();
